import { Grid, Typography } from "@mui/material";
import { memo } from "react";
import { FormInput } from "@4uhub/lib4uhub";
import { useTranslation } from "react-i18next";
import { IRuleParamIfProps } from "./models";

const translationPath = "page.4uBus.integrationRule.integrationRuleParam.";

export const RuleParamIf = memo(
  ({ uBusAutomationParam, busAutomationCode }: IRuleParamIfProps) => {
    const { t } = useTranslation();

    const isAutomationCodeTen = busAutomationCode === 10;

    const automationCodeTenFields = [
      {
        label: t(translationPath + "procedure"),
        codeName: "ifOneCode",
        valueName: "ifOneName",
      },
      {
        label: t(translationPath + "procedure_origin"),
        codeName: "ifTwoCode",
        valueName: "ifTwoName",
      },
      {
        label: t(translationPath + "internal_procedure"),
        codeName: "ifThreeCode",
        valueName: "ifThreeName",
      },
      {
        label: t(translationPath + "material"),
        codeName: "ifFourCode",
        valueName: "ifFourName",
      },
    ] as const;

    const ifOneLabel =
      uBusAutomationParam?.code === "1"
        ? t(translationPath + "establishment")
        : uBusAutomationParam?.code === "2"
          ? t(translationPath + "insurance")
          : t(translationPath + "sector");
    const ifTwoLabel =
      uBusAutomationParam?.code === "2"
        ? t(translationPath + "category")
        : t(translationPath + "basic_unit");
    const ifThreeLabel = t(translationPath + "complementary_unit");

    if (isAutomationCodeTen) {
      return (
        <Grid
          container
          spacing={2}
          sx={(t) => ({
            mt: 5,
            pr: 3,
            pl: 1,
            py: 3,
            border: `1px solid ${t.palette.divider}`,
            borderRadius: 2,
          })}
        >
          <Grid item sm={12}>
            <Typography fontWeight="bold">{t(translationPath + "if")}</Typography>
          </Grid>

          {automationCodeTenFields.map(({ label, codeName, valueName }) => (
            <Grid key={codeName} item display="flex" flexDirection="row" xs={12} gap={2}>
              <Grid item xs={3} textAlign="end" alignSelf="center">
                <Typography fontWeight="bold">{label}</Typography>
              </Grid>

              <Grid item xs={4.5}>
                <FormInput
                  size="small"
                  name={valueName}
                  fullWidth
                  label={t(translationPath + "source_name")}
                />
              </Grid>

              <Grid item xs={4.5}>
                <FormInput
                  size="small"
                  name={codeName}
                  fullWidth
                  label={t(translationPath + "source_value")}
                />
              </Grid>
            </Grid>
          ))}
        </Grid>
      );
    }

    return (
      <Grid
        container
        spacing={2}
        sx={(t) => ({
          mt: 5,
          pr: 3,
          pl: 1,
          py: 3,
          border: `1px solid ${t.palette.divider}`,
          borderRadius: 2,
        })}
      >
        <Grid item sm={12}>
          <Typography fontWeight="bold">{t(translationPath + "if")}</Typography>
        </Grid>

        <Grid item display="flex" flexDirection="row" xs={12} gap={2}>
          <Grid item xs={3} textAlign="end" alignSelf="center">
            <Typography fontWeight="bold">{ifOneLabel}</Typography>
          </Grid>

          <Grid item xs={4.5}>
            <FormInput
              size="small"
              name="ifOneName"
              fullWidth
              label={t(translationPath + "source_name")}
            />
          </Grid>

          <Grid item xs={4.5}>
            <FormInput
              size="small"
              name="ifOneCode"
              fullWidth
              label={t(translationPath + "source_value")}
            />
          </Grid>
        </Grid>

        {uBusAutomationParam?.code !== "1" && (
          <Grid item display="flex" flexDirection="row" xs={12} gap={2}>
            <Grid item xs={3} textAlign="end" alignSelf="center">
              <Typography fontWeight="bold">{ifTwoLabel}</Typography>
            </Grid>

            <Grid item xs={4.5}>
              <FormInput
                size="small"
                name="ifTwoName"
                fullWidth
                label={t(translationPath + "source_name")}
              />
            </Grid>

            <Grid item xs={4.5}>
              <FormInput
                size="small"
                name="ifTwoCode"
                fullWidth
                label={t(translationPath + "source_value")}
              />
            </Grid>
          </Grid>
        )}

        {uBusAutomationParam?.code === "3" && (
          <Grid item display="flex" flexDirection="row" xs={12} gap={2}>
            <Grid item xs={3} textAlign="end" alignSelf="center">
              <Typography fontWeight="bold">{ifThreeLabel}</Typography>
            </Grid>

            <Grid item xs={4.5}>
              <FormInput
                size="small"
                name="ifThreeName"
                fullWidth
                label={t(translationPath + "source_name")}
              />
            </Grid>

            <Grid item xs={4.5}>
              <FormInput
                size="small"
                name="ifThreeCode"
                fullWidth
                label={t(translationPath + "source_value")}
              />
            </Grid>
          </Grid>
        )}
      </Grid>
    );
  },
);
